export default __webpack_public_path__ + "static/media/diamond-cut-2@2x.17434c8f.jpg";